const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Integraciones de Colas (N8N / Typebot / Dialogflow)",
    summary:
      "Conecta flujos externos de inteligencia artificial, Typebot, Dialogflow o N8N a tus colas de atención para responder de manera automática e interactiva antes de transferir a un agente humano.",
  },
  sections: [
    {
      id: "proveedores_integracion",
      title: "1. Proveedores y Tipos de Integración",
      description:
        "Soporte para plataformas líderes de automatización y bots externos.",
      items: [
        {
          id: "typebot_integracion",
          title: "Typebot",
          definition:
            "Conecta flujos de Typebot indicando la URL del servidor y el identificador de bot para crear experiencias conversacionales interactivas.",
        },
        {
          id: "dialogflow_integracion",
          title: "Dialogflow (Google Cloud)",
          definition:
            "Configura proyectos de Dialogflow para comprensión de lenguaje natural e intenciones personalizadas con credenciales JSON de Google.",
        },
        {
          id: "n8n_integracion",
          title: "N8N y Webhooks Personalizados",
          definition:
            "Envía y recibe datos de flujos de trabajo en N8N para automatizaciones complejas y consultas a bases de datos externas.",
        },
      ],
    },
    {
      id: "asignacion_colas",
      title: "2. Asignación a Departamentos",
      description:
        "Vincula cada integración a una cola específica para gestionar el enrutamiento del ticket.",
      items: [
        {
          id: "cola_vinculada",
          title: "Cola de Atención Asociada",
          definition:
            "Cuando un cliente entra a la cola seleccionada, el bot o integración externa toma el control inmediato de la conversación.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Queue Integrations (N8N / Typebot / Dialogflow)",
    summary:
      "Connect external AI bots, Typebot, Dialogflow, or N8N workflows directly to your support queues to converse automatically before routing to human agents.",
  },
  sections: [
    {
      id: "proveedores_integracion",
      title: "1. Integration Providers",
      description:
        "Support for external conversational platforms and automation engines.",
      items: [
        {
          id: "typebot_integracion",
          title: "Typebot",
          definition:
            "Connect Typebot flows specifying viewer URL and bot name for interactive customer onboarding.",
        },
        {
          id: "dialogflow_integracion",
          title: "Dialogflow (Google Cloud)",
          definition:
            "Configure Dialogflow agents for natural language processing using Google service account credentials.",
        },
        {
          id: "n8n_integracion",
          title: "N8N & Webhook Automations",
          definition:
            "Trigger N8N workflows to query databases, call external APIs, and return smart answers.",
        },
      ],
    },
    {
      id: "asignacion_colas",
      title: "2. Queue Association",
      description:
        "Link each integration to a specific department for seamless conversation handling.",
      items: [
        {
          id: "cola_vinculada",
          title: "Associated Support Queue",
          definition:
            "When a contact selects the designated queue, the external integration takes over the conversation immediately.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Integrações de Filas (N8N / Typebot / Dialogflow)",
    summary:
      "Conecte fluxos externos de IA, Typebot, Dialogflow ou N8N às suas filas de atendimento para responder de forma inteligente antes de transferir para um atendente humano.",
  },
  sections: [
    {
      id: "proveedores_integracion",
      title: "1. Provedores de Integração",
      description:
        "Suporte a bots externos e motores de automação líderes de mercado.",
      items: [
        {
          id: "typebot_integracion",
          title: "Typebot",
          definition:
            "Integre fluxos do Typebot fornecendo a URL e o nome do bot para experiências interativas.",
        },
        {
          id: "dialogflow_integracion",
          title: "Dialogflow (Google Cloud)",
          definition:
            "Configure agentes Dialogflow com processamento de linguagem natural usando credenciais JSON do Google.",
        },
        {
          id: "n8n_integracion",
          title: "N8N e Webhooks",
          definition:
            "Dispare fluxos no N8N para consultas em sistemas externos e regras de negócio avançadas.",
        },
      ],
    },
    {
      id: "asignacion_colas",
      title: "2. Associação com Filas",
      description:
        "Vincule cada integração a um setor específico para controle de atendimento.",
      items: [
        {
          id: "cola_vinculada",
          title: "Fila de Atendimento Vinculada",
          definition:
            "Assim que o cliente escolhe a fila correspondente, o bot externo assume a conversa automaticamente.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Intégrations de Files d'Attente (N8N / Typebot / Dialogflow)",
    summary:
      "Connectez des bots externes, Typebot, Dialogflow ou N8N à vos files d'attente pour répondre intelligemment avant le transfert vers un agent humain.",
  },
  sections: [
    {
      id: "proveedores_integracion",
      title: "1. Fournisseurs d'Intégration",
      description:
        "Compatibilité avec les plateformes d'automatisation et de chatbot.",
      items: [
        {
          id: "typebot_integracion",
          title: "Typebot",
          definition:
            "Associez des parcours Typebot avec l'URL du serveur et le nom du bot pour guider vos visiteurs.",
        },
        {
          id: "dialogflow_integracion",
          title: "Dialogflow (Google Cloud)",
          definition:
            "Connectez vos agents Dialogflow en utilisant les identifiants JSON du compte de service Google.",
        },
        {
          id: "n8n_integracion",
          title: "N8N et Webhooks",
          definition:
            "Exécutez des flux N8N pour synchroniser vos bases de données ou déclencher des actions externes.",
        },
      ],
    },
    {
      id: "asignacion_colas",
      title: "2. Liaison aux Files",
      description:
        "Associez chaque intégration au département approprié.",
      items: [
        {
          id: "cola_vinculada",
          title: "File d'Attente Associée",
          definition:
            "Dès que le client sélectionne la file, le bot externe prend en charge l'échange instantanément.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "تكاملات الأقسام (N8N / Typebot / Dialogflow)",
    summary:
      "اربط روبوتات المحادثة الخارجية مثل Typebot وDialogflow وتدفقات N8N بأقسام الدعم للرد التفاعلي الذكي قبل التحويل للموظف البشري.",
  },
  sections: [
    {
      id: "proveedores_integracion",
      title: "1. مزودو التكامل الخارجي",
      description:
        "دعم منصات الأتمتة والذكاء الاصطناعي الرائدة.",
      items: [
        {
          id: "typebot_integracion",
          title: "Typebot",
          definition:
            "اربط تدفقات Typebot عبر رابط الخادم واسم الروبوت لتقديم تجارب محادثة تفاعلية.",
        },
        {
          id: "dialogflow_integracion",
          title: "Dialogflow (Google Cloud)",
          definition:
            "إعداد وكلاء Dialogflow لفهم اللغة الطبيعية باستخدام ملف مفاتيح JSON من Google Cloud.",
        },
        {
          id: "n8n_integracion",
          title: "N8N وWebhooks",
          definition:
            "تشغيل تدفقات عمل متقدمة في N8N للاستعلام من قواعد البيانات والأنظمة الخارجية.",
        },
      ],
    },
    {
      id: "asignacion_colas",
      title: "2. الربط مع الأقسام",
      description:
        "ربط كل تكامل بقسم محدد لتوجيه المحادثات بسلاسة.",
      items: [
        {
          id: "cola_vinculada",
          title: "القسم المرتبط",
          definition:
            "بمجرد اختيار العميل للقسم، يتولى الروبوت أو النظام الخارجي الرد على المحادثة فوراً.",
        },
      ],
    },
  ],
};

export const QUEUE_INTEGRATION_HELP_DATA = { es, en, pt, fr, ar };
export default QUEUE_INTEGRATION_HELP_DATA;
